export default {
  setPageContent(state, { data, routetemplate }) {
    state.content[routetemplate] = data
  },
  setMainConfig(state, value) {
    state.mainConfig = value
  },
  setEngineContent(state, {data, view}) {
    state.engine[view] = data
  },
  clearMainConfig(state) {
    state.mainConfig = null
  }
}
